import rootService from 'core/services.root';

export default rootService({
    deleteChatbotFeature: ['DELETE', '/chatbot/node/:feature/delete'],
    deleteChatbotNode: ['DELETE', '/chatbot/node/delete/:id'],
    deleteNotification: ['DELETE', '/external-notification/delete/:id'],
    deleteTemplate: ['DELETE', '/template/delete/:id'],
    fetchBackendConfiguration: ['GET', '/admin/platform/configuration'],
    fetchChatbotFeatureList: ['GET', '/chatbot/feature/list'],
    fetchChatbotJSON: ['GET', '/chatbot/export'],
    fetchConfig: ['GET', '/configurations/all'],
    fetchConfigNotificationTypes: ['GET', '/external-notification/types'],
    fetchConfigNotifications: ['GET', '/external-notification/all'],
    fetchConfigTemplates: ['GET', '/template/all'],
    fetchCronConfiguration: ['GET', '/admin/platform/command'],
    fetchFeatureConfiguration: ['GET', '/chatbot/node/:feature/list'],
    fetchServicesConfiguration: ['GET', '/admin/platform/external-service'],
    postChatbotNode: ['POST', '/chatbot/node/store'],
    postNotification: ['POST', '/external-notification/store'],
    postTemplate: ['POST', '/template/store'],
    putBackendConfiguration: ['PUT', '/admin/platform/configuration/update'],
    putChatbotFeature: ['PUT', '/chatbot/import'],
    putChatbotNode: ['PUT', '/chatbot/node/update/:id'],
    putCronConfiguration: ['PUT', '/admin/platform/command/update'],
    putFeatureSchema: ['PUT', '/chatbot/node/position/update'],
    putNotification: ['PUT', '/external-notification/update/:id'],
    putServicesConfiguration: ['PUT', '/admin/platform/external-service/update'],
    putTemplate: ['PUT', '/template/update/:id']
});
